<template>
<div class="chapter">
<div class="inner_page">
<h1>The Crime</h1>
<h1 class="sigil_not_in_toc">At Vanderlynden’s</h1>
<h2 class="sigil_not_in_toc">R. H. Mottram</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?31d7aade